import { Link } from "react-router-dom";
import { useApp } from "@/lib/AppContext";

const T = {
  ar: {
    tagline: "نظافة لا تعرف الحدود 🌙",
    quickLinks: "روابط سريعة",
    links: [
      { label: "الرئيسية", href: "#hero" },
      { label: "خدماتنا", href: "#services" },
      { label: "تقديم طلب", href: "/laundry" },
      { label: "عجلة العروض", href: "/wheel" },
      { label: "من نحن", href: "/about" },
      { label: "تواصل معنا", href: "/contact" },
    ],
    contact: "تواصل معنا",
    rights: "جميع الحقوق محفوظة",
    adminLink: "لوحة التحكم",
  },
  en: {
    tagline: "Cleanliness Knows No Bounds 🌙",
    quickLinks: "Quick Links",
    links: [
      { label: "Home", href: "#hero" },
      { label: "Services", href: "#services" },
      { label: "Book Order", href: "/laundry" },
      { label: "Offers Wheel", href: "/wheel" },
      { label: "About", href: "/about" },
      { label: "Contact", href: "/contact" },
    ],
    contact: "Contact Us",
    rights: "All Rights Reserved",
    adminLink: "Admin Panel",
  }
};

export default function LandingFooter() {
  const { lang } = useApp();
  const tr = T[lang] || T.ar;
  const isAr = lang === "ar";

  const scrollTo = (href) => {
    if (href.startsWith("#")) {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-[#0e1f3d] text-white pt-14 pb-6" dir={isAr ? "rtl" : "ltr"}>
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div className="space-y-3">
            <div className="flex items-center gap-3">
              <img src="https://media.base44.com/images/public/user_69729b1c2410c5c031f1d29a/291b90bb1_.png" alt="logo" className="w-12 h-12 object-contain" />
              <div>
                <p className="font-black text-white text-base">{isAr ? "مغاسل القمر الأبيض" : "White Moon Laundry"}</p>
              </div>
            </div>
            <p className="text-white/60 text-sm leading-relaxed">{tr.tagline}</p>
          </div>

          {/* Quick Links */}
          <div>
            <p className="font-black text-white mb-4">{tr.quickLinks}</p>
            <ul className="space-y-2">
              {tr.links.map((l, i) => (
                <li key={i}>
                  {l.href.startsWith("#") ? (
                    <button onClick={() => scrollTo(l.href)}
                      className="text-white/60 hover:text-white text-sm transition-colors">
                      {l.label}
                    </button>
                  ) : (
                    <Link to={l.href} className="text-white/60 hover:text-white text-sm transition-colors">
                      {l.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="font-black text-white mb-4">{tr.contact}</p>
            <div className="flex flex-col gap-3">
              <a href="tel:0504175289"
                className="flex items-center gap-3 bg-white/10 hover:bg-white/20 text-white font-bold px-4 py-3 rounded-2xl transition-colors border border-white/20">
                <span className="text-xl w-9 h-9 flex items-center justify-center bg-white/15 rounded-xl shadow-inner">📞</span>
                <span className="text-sm tracking-wide">0504175289</span>
              </a>
              <a href="https://maps.app.goo.gl/WdENh7iS6kAEuV2e6" target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-3 bg-white/10 hover:bg-white/20 text-white font-bold px-4 py-3 rounded-2xl transition-colors border border-white/20">
                <span className="text-xl w-9 h-9 flex items-center justify-center bg-white/15 rounded-xl shadow-inner">📍</span>
                <span className="text-sm">{isAr ? "السادس عشر، الخبر 34446" : "16th District, Khobar 34446"}</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <p>© {new Date().getFullYear()} {isAr ? "مغاسل القمر الأبيض — " : "White Moon Laundry — "}{tr.rights}</p>
          <a
            href="https://wa.me/966551288662"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white/70 transition-colors"
          >
            By Anas.B360
          </a>
        </div>
      </div>
    </footer>
  );
}